import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import { Container } from "./container";
import { media } from "./media-queries";
import LogoImage from "../images/Luke-Gamble-Logo-Top.png";
import BackgroundImage from "../images/texture-over-dark.png";
import BackgroundBorderImage from "../images/Border-Blue-Bottom.png";

const HeaderStyled = styled.header`
  background: url(${BackgroundImage}) 0 0 repeat
    ${(props) => props.theme.colours.primary};
  height: 52px;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 20;

  &::after {
    background: url(${BackgroundBorderImage}) 0 0 repeat-x;
    content: "";
    ${(props) =>
      props.showMobileMenu ? "display: none;" : "display: inline-block;"}
    height: 16px;
    position: relative;
    top: -3px;
    width: 100%;
  }
`;

const ContainerStyled = styled(Container)`
  display: flex;
`;

const Logo = styled.img`
  left: 0;
  width: 230px;
  position: absolute;
  top: 0;
  transition: width 250ms ease;
  z-index: 12;

  ${media.lg} {
    width: 320px;

    &.small {
      width: 230px;
    }
  }
`;

const MobileMenuButton = styled.div`
  align-self: flex-end;
  display: block;
  margin: 13px 0 13px 13px;
  line-height: 26px;
  font-weight: 700;
  display: inline-block;
  text-decoration: none;
  color: #fff;
  cursor: pointer;

  ${media.lg} {
    display: none;
  }
`;

const MainNav = styled.nav`
  background: url(${BackgroundImage}) 0 0 repeat
    ${(props) => props.theme.colours.primary};
  ${(props) => (props.showMobileMenu ? "display: block;" : "display: none;")}
  left: 0;
  padding: 20px 0 0 0;
  position: absolute;
  top: 52px;
  width: 100%;
  z-index: 11;

  &::after {
    background: url(${BackgroundBorderImage}) 0 0 repeat-x;
    content: "";
    display: inline-block;
    height: 16px;
    position: relative;
    top: 20px;
    width: 100%;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;

    a {
      display: block;
      text-align: center;
    }
  }

  ${media.lg} {
    align-self: flex-end;
    background: none;
    display: block;
    left: initial;
    padding: 0;
    position: relative;
    top: 0;
    width: auto;

    &::after {
      display: none;
    }

    ul {
      display: flex;
    }
  }
`;

const MenuLink = styled(Link)`
  margin: 13px 0;
  padding: 0 13px;
  line-height: 26px;
  font-weight: 700;
  display: inline-block;
  text-decoration: none;
  color: #fff;

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  &.active {
    border-bottom: 2px solid rgba(255, 255, 255, 0.35);
    border-top: 2px solid rgba(255, 255, 255, 0.35);
    margin: 11px 0 11px 0;
  }
`;

export const Header = () => {
  const [shouldShowMenu, setShowMenu] = useState(false);

  useEffect(() => {
    function logoSize() {
      let logo = document.querySelector(".logo");
      let scroll = window.scrollY;

      scroll > 0 ? logo.classList.add("small") : logo.classList.remove("small");
    }
    window.addEventListener("scroll", logoSize, { passive: true });

    return () => {
      window.removeEventListener("scroll", logoSize);
    };
  }, []);

  return (
    <HeaderStyled showMobileMenu={shouldShowMenu}>
      <ContainerStyled>
        <Link to="/">
          <Logo className="logo" src={LogoImage} />
        </Link>
        <MobileMenuButton onClick={() => setShowMenu(!shouldShowMenu)}>
          Menu
        </MobileMenuButton>
        <MainNav showMobileMenu={shouldShowMenu}>
          <ul>
            <li>
              <MenuLink to="/" activeClassName="active">
                Home
              </MenuLink>
            </li>
            <li>
              <MenuLink to="/latest" activeClassName="active">
                Latest
              </MenuLink>
            </li>
            <li>
              <MenuLink to="/writing" activeClassName="active">
                Writing
              </MenuLink>
            </li>
            <li>
              <MenuLink to="/charities" activeClassName="active">
                Charities
              </MenuLink>
            </li>
            <li>
              <MenuLink to="/show-reel" activeClassName="active">
                Show Reel
              </MenuLink>
            </li>
            <li>
              <MenuLink to="/bio" activeClassName="active">
                Bio
              </MenuLink>
            </li>
            <li>
              <MenuLink to="/contact" activeClassName="active">
                Contact
              </MenuLink>
            </li>
          </ul>
        </MainNav>
      </ContainerStyled>
    </HeaderStyled>
  );
};
